import MeaButton from "../../../../components/MeaButton";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { forwardRef, useImperativeHandle, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import contractsAPI from "../../../../services/contracts";
import MeaMemberAvatar from "../../../../components/MeaMemberAvatar";
import { PERMISSION_TRAINING_CONTRACTS } from "../../../../permissions";
import MeaStudentAvatar from "../../../trainings/components/MeaStudentAvatar";
import MeaContractTotalAmount from "../../../registrations/components/MeaContractTotalAmount";
const CreateOrAssociateContractModal = forwardRef((props, ref) => {

    const schoolId = props?.schoolId;
    const trainingId = props?.trainingId;
    const accessToken = "";

    const [student, setStudent] = useState();
    const [studentId, setStudentId] = useState();
    const [parentsIds, setParentsIds] = useState("");
    const [active, setActive] = useState(false);
    const [callbackFn, setCallbackFn] = useState(() => { });

    const [selectedContract, setSelectedContract] = useState(null);

    const queryList = contractsAPI.useGetList(schoolId, trainingId, accessToken, 1, 20, {
        parents_ids: parentsIds
    });

    useImperativeHandle(ref, () => ({
        show: (_student, callback) => {
            setStudent(_student);
            setStudentId(_student?.id);
            setParentsIds([_student?.father_id, _student?.mother_id].filter(id => id != null).join(","));
            setCallbackFn(() => callback);
            setActive(true);
        },
    }));

    const handleCreateContract = () => {
        console.log("studentId", studentId);
        contractsAPI.CreateOne(schoolId, trainingId, accessToken, {
            student_id: studentId,

        }).then((data) => {
            setActive(false);
            callbackFn();
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const handleAssociateContract = () => {
        contractsAPI.UpdateContractStudents(schoolId, trainingId, accessToken, selectedContract?.id, {
            action: "ADD",
            students_ids: [studentId]
        }).then((data) => {
            setActive(false);
            callbackFn();
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    return (
        <Dialog header="Créer ou associer un contrat" visible={active} style={{ width: '80vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}
            onHide={() => { setActive(false); }}>
            <p>
                Chaque élève doit avoir un contrat pour pouvoir poursuivre ses études dans l'école.
                Vous pouvez créer un nouveau contrat ou l'associer à un contrat existant.
            </p>

            <Divider />
            <p>
                Choisir un contrat existant de la famille:
            </p>
            <DataTable showGridlines value={queryList?.data?.data} selectionMode="single" selection={selectedContract}
                onSelectionChange={(e) => setSelectedContract(e.value)} dataKey="id"
                emptyMessage="Aucun contrat trouvé!">
                <Column
                    selectionMode="single"
                    headerStyle={{ width: "3rem" }}
                ></Column>
                <Column
                    field="id"
                    header="N° de contrat"
                ></Column>
                <Column
                    field="students"
                    header="Élèves actuels"
                    body={(item) => (
                        <>
                            {item?.students?.map((student, index) => (
                                <MeaStudentAvatar key={index} student={student} schoolId={schoolId} trainingId={trainingId} />
                            ))}
                        </>
                    )}
                ></Column>
                <Column
                    field="parents"
                    header="Parents"
                    body={(item) => (
                        <div className="flex gap-3">
                            {item?.parents?.map((parent, index) => (
                                <MeaMemberAvatar key={index} member={parent} />
                            ))}
                        </div>
                    )}
                ></Column>
                <Column
                    field="total_amount"
                    header="Total actuel"
                    body={(item) => (
                        <>
                            <MeaContractTotalAmount contract={item} schoolId={schoolId} trainingId={trainingId} />
                        </>
                    )}
                ></Column>
            </DataTable>
            <div className="flex flex-column mt-2">
                <MeaButton permission={PERMISSION_TRAINING_CONTRACTS.UPDATE} disabled={!selectedContract} severity="success" size="large" label="Associer ce contrat existant" onClick={handleAssociateContract} />
            </div>
            <Divider>
                <b>OU</b>
            </Divider>
            <div className="flex flex-column">
                <MeaButton permission={PERMISSION_TRAINING_CONTRACTS.CREATE} outlined severity="success" size="large" label="Créer un nouveau contrat" onClick={handleCreateContract} />
            </div>
        </Dialog>
    )
});

export default CreateOrAssociateContractModal;
